import _orderBy from 'lodash/orderBy';

/**
 * Sorts `rows` in a case insensitive manner according to the
 * options provided by `sortBy`.
 *
 * @param {Array<object>} rows The table rows to sort.
 * @param {Array<object>} sortBy The current sort options.
 * @returns A sorted array of `rows`.
 */
export const sortRows = (rows, sortBy = []) => {
  if (!sortBy.length) {
    return rows;
  }

  const { directions, columns } = sortBy.reduce(
    (acc, { direction, id: column }) => {
      acc.columns.push(row => toString(row[column]).toLowerCase());
      acc.directions.push(direction);
      return acc;
    },
    { columns: [], directions: [] }
  );

  return _orderBy(rows, columns.filter(Boolean), directions);
};

const toString = str => {
  if (typeof str === 'string') {
    return str;
  }

  if (typeof str === 'number') {
    if (isNaN(str) || str === Infinity || str === -Infinity) {
      return '';
    }
    return String(str);
  }

  if (typeof str === 'boolean') {
    return String(str);
  }

  return '';
};
